var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOutLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M15.266 4h3.61C21.151 4 23 5.792 23 8v8c0 2.208-1.848 4-4.125 4h-3.609a.51.51 0 01-.516-.5v-1.667c0-.275.232-.5.516-.5h3.61c.76 0 1.374-.596 1.374-1.333V8c0-.738-.614-1.333-1.375-1.333h-3.609a.51.51 0 01-.516-.5V4.5c0-.275.232-.5.516-.5zM10.2 16.63l-3.334-2.963h8.228c.572 0 1.031-.446 1.031-1v-1.334c0-.554-.46-1-1.03-1H6.866L10.2 7.371a.983.983 0 00.035-1.446l-.941-.913a1.06 1.06 0 00-1.457-.004l-6.53 6.284a.975.975 0 000 1.42l6.526 6.276a1.053 1.053 0 001.456-.005l.941-.912a.977.977 0 00-.03-1.442z"
  }))));
}

export default SvgSignOutLeft;